import React, { useCallback } from 'react';
import { Container, Card, Box } from '@material-ui/core';
import { Save } from '../../../components';
import { useParams } from 'react-router-dom';
import { useText, useGetData, usePutData, usePostData } from '../../../hooks';
import useStore from '../../../context';
import * as Api from '../../../service/index';
import NumberFormat from 'react-number-format';

const initForm = {
  phone: '',
};

const Form = () => {
  const { id } = useParams();
  const [data, loading, refresh] = useGetData(
    id && Api.contacts_phone.getById,
    id
  );
  const postCallback = usePostData(Api.contacts_phone.create, refresh);
  const updateCallback = usePutData(Api.contacts_phone.update, refresh);
  const { setErrorMsg, lang } = useStore();

  const [text, setText, textChange, input] = useText(data?.data || initForm);


  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();

      id ? updateCallback(text, id) : postCallback(text);
    },
    [text, setErrorMsg, id, updateCallback, postCallback]
  );
  
  return (
    <Container>
      <Card className="shadow-xxl px-4 py-2">
        <Box component="form" onSubmit={submitForm}>

        <div className="d-flex align-items-center">
            <div className="w-100">Phone Number
              <div className="MuiOutlinedInput-root custom-number-input" >
                  {text && <NumberFormat {...input('phone')}  format="+### ## ## ## ##" placeholder="374 -- -- -- --"
                  className="MuiInputBase-input MuiOutlinedInput-input" />}
              </div>
            </div>
          </div>
          <Save />
        </Box>
      </Card>
    </Container>
  );
};

export default Form;
